export default "__VITE_ASSET__YHFMxl4d__"